export function SearchIcon (): JSX.Element {
  return <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 7H44M4 23H15M4 39H15" stroke="#722A82" strokeWidth="4" strokeLinecap="round"/>
    <path d="M31.5 34C33.7543 34 35.9163 33.1045 37.5104 31.5104C39.1045 29.9163 40 27.7543 40 25.5C40 23.2457 39.1045 21.0837 37.5104 19.4896C35.9163 17.8955 33.7543 17 31.5 17C29.2457 17 27.0837 17.8955 25.4896 19.4896C23.8955 21.0837 23 23.2457 23 25.5C23 27.7543 23.8955 29.9163 25.4896 31.5104C27.0837 33.1045 29.2457 34 31.5 34Z" stroke="#722A82" strokeWidth="4"/>
    <path d="M37 32L44 39.05" stroke="#722A82" strokeWidth="4" strokeLinecap="round"/>
  </svg>
}
